import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import routes from "../../router/breadcrumsRoutes";
import { ROUTES } from "../../router/routes";

export const APP_TITLE = "Koaala Admin";

const sortedRoutes = [...routes].sort((a, b) => b.path.length - a.path.length);

export const getPageTitle = (pathname) => {
  for (const route of sortedRoutes) {
    const match = matchPath(pathname, {
      path: route.path,
      exact: route.exact !== false,
    });
    if (match) {
      return route.name;
    }
  }
  if (pathname === ROUTES.APP) {
    return "Dashboard";
  }
  return null;
};

const DocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(pathname);
    document.title = pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE;
  }, [pathname]);

  return null;
};

export default DocumentTitle;
